"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPartsInput = {
    type: "structure",
    required: ["Bucket", "Key", "UploadId"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            },
            location: "uri",
            locationName: "Key"
        },
        MaxParts: {
            shape: {
                type: "integer"
            },
            location: "querystring",
            locationName: "max-parts"
        },
        PartNumberMarker: {
            shape: {
                type: "integer"
            },
            location: "querystring",
            locationName: "part-number-marker"
        },
        UploadId: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "uploadId"
        },
        RequestPayer: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-payer"
        }
    }
};
//# sourceMappingURL=ListPartsInput.js.map